import { render, staticRenderFns } from "./StatementsOH.vue?vue&type=template&id=1237d3c3&"
import script from "./StatementsOH.vue?vue&type=script&lang=js&"
export * from "./StatementsOH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatementsOH.vue"
export default component.exports